// Exposing all callbales to the client

export { callables as workspaces } from "./workspaces/callables";
export { callables as slides } from "./slides/callables";
export { callables as clientLogs } from "./clientLogs/callables";
